import { Component, Input, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { Subscription, lastValueFrom } from 'rxjs';

import { CommonService } from '@app/services/common.service';
import { EventViewerService } from '@app/services/event-viewer.service';
import { EventsService } from '@app/services/events.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BaseComponent } from '@app/directives/base-component';

import ims from '../../../../../imports'
import { Helper } from 'src/4services/2helper';

@Component({
    selector: 'log_box_timelapse',
    templateUrl: './timelapse.component.html',
    styleUrls: ['../../../../common.scss', '../../c_card_event_viewer_box.component.scss'],
    standalone: false
})
export class log_box_timelapse_component extends BaseComponent {
  @Input() log;
  @Input() timezone;
  @Input() toolbar: TemplateRef<any>;

  snapshotPermission = false;
  isBrokenImage = false;
  isShowPlayBtn = false;
  isShowVideo = false;
  isLoadingVideo = false;

  IPuserName = ''

  constructor(
    public commonService: CommonService,
    private eventViewerService: EventViewerService,
    private eventsService: EventsService,
    private helper: Helper,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  private snapshotPermission$w: Subscription;
  watch() {
    this.snapshotPermission$w = this.eventViewerService.snapshotPermission$w.subscribe((v) => this.snapshotPermission = v);
  }
  unwatch() {
    this.snapshotPermission$w?.unsubscribe();
  }
  ngOnInit() {
    this.watch()
    if(this.log.email && this.log.ip) this.getIPUserName()
  }
  ngOnDestroy(){
    super.ngOnDestroy();
    this.unwatch()
  }

  // -------------------------------------------------------
  // COMMON

  showToolbar = ims._.throttle(this.showToolbarThrottle.bind(this), 200);
  onHoverLog(e, id){
    e.stopPropagation();
    this.showToolbar(id)
  }
  showToolbarThrottle(id){
    const toolbox = document.getElementById('log-box-toolbox'+id)
    if(toolbox) toolbox.style.visibility = 'visible';
  }

  hiddenToolbar = ims._.throttle(this.hiddenToolbarThrottle.bind(this), 200);
  onMouseLeaveLog(e, log){
    e.stopPropagation();
    this.hiddenToolbar(log)
  }
  hiddenToolbarThrottle(log){
    log.isShowMenu = false
    const toolbox = document.getElementById('log-box-toolbox'+log.id)
    if(toolbox) toolbox.style.visibility = 'hidden';
  }
  

  parseWarningLog() {
    let isWarning = false;
    if (this.log.is_send_xml_signal === 2) {
      isWarning = true;
    }
    if (this.log.status) {
      if (this.log.status > 300) {
        isWarning = true;
      }
    } else {
      isWarning = true;
    }
    return isWarning;
  }

  isAutomationRule(){
    const description = this.log?.description.toLowerCase() ?? ''
    const isAutomationRule = description.includes('automation') || this.log.isAutomation
    return isAutomationRule
  }

  // --------------------------------
  // Viewed
  getIPUserName(){
    if(!this.log.email) return
    if(!this.log.user_id) return
    if(this.log.email != this.log.ip) return // 이건 일반 유저가 본 것

    const user = this.helper.dealer_member.ipMmeber(this.log.user_id)
    this.IPuserName = user?.name ?? 'No Name'
  }
  // --------------------------------

  // --------------------------------
  // IMAGE / VIDEO
  computedBackground(){
    if(this.log.isLoading) return 'loading-background'
    if(!this.snapshotPermission) return 'no-permission'

    if(!this.isShowVideo) {
      if(this.canIShowImage() === 'need to upgrade plan') return 'no-permission'
      if(this.canIShowImage() === 'expired') return 'no-permission'
      if(this.canIShowImage() === 'privacy mode') return 'no-permission'
      if(this.canIShowImage() === 'broken image') return 'no-permission'
      if(this.canIShowImage() === 'image') return 'full-height'
      if(this.canIShowImage() === 'default') return 'timelapse'
    } else {
      if(this.canIShowVideo() === 'need to upgrade plan') return 'no-permission'
      if(this.canIShowVideo() === 'expired') return 'no-permission'
      if(this.canIShowVideo() === 'privacy mode') return 'no-permission'
      if(this.canIShowVideo() === 'broken video') return 'no-permission'
      if(this.canIShowVideo() === 'video') return 'full-height'
      if(this.canIShowVideo() === 'default') return 'timelapse'
    }
  }

  canIShowImage(){
    const highestPlan = this.helper.dealer_plan.isPremiumPlan() || this.helper.dealer_plan.isResellerPlan()
    if(!this.snapshotPermission) return 'no permission'
    if(highestPlan && this.log.is_expired) return 'expired'
    if(!highestPlan && this.log.is_expired) return 'need to upgrade plan'
    if(this.log.isPrivacy) return 'privacy mode'
    if(this.isBrokenImage) return 'broken image'
    if(this.log.imageUrl) return 'image'
    return 'default'
  } 
  canIShowVideo(){
    const highestPlan = this.helper.dealer_plan.isPremiumPlan() || this.helper.dealer_plan.isResellerPlan()
    if(!this.snapshotPermission) return 'no permission'
    if(highestPlan && this.log.is_expired) return 'expired'
    if(!highestPlan && this.log.is_expired) return 'need to upgrade plan'
    if(this.log.isPrivacy) return 'privacy mode'
    if(this.log.videoUrl && !this.log.safetyVideoUrl) return 'broken video'
    if(this.log.safetyVideoUrl) return 'video'
    return 'default'
  } 

  toggleToVideo(e){
    e.stopPropagation()
    if(!this.log.videoUrl) return

    this.isShowVideo = !this.isShowVideo
    if(this.isShowVideo) {
      this.log.isLoading = true
      this.getMP4Video(this.log, this.log.videoUrl)
    }
  }

  mouseOverImage(e){
    e.stopPropagation();
    if(!this.log.videoUrl) return
    this.isShowPlayBtn = true
  }
  mouseLeaveImage(e){
    e.stopPropagation();
    if(!this.log.videoUrl) return
    this.isShowPlayBtn = false
  }

  imgLoaded(){
    let urlCreator = window.URL;
    urlCreator.revokeObjectURL(this.log.imageUrl)
  }

  imgError(err){
    console.log('image error',err)
    this.isBrokenImage = true
    let urlCreator = window.URL;
    urlCreator.revokeObjectURL(this.log.imageUrl)
  }

  async getMP4Video(log, url) {
    let urlCreator = window.URL;
    try {
      const res = await lastValueFrom(this.eventsService.getSnapshotFromUrl(url))
      console.log(res, this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(res)))
      log['safetyVideoUrl'] = this.sanitizer.bypassSecurityTrustUrl(urlCreator.createObjectURL(res));
      log.isLoading = false 
      this.cdr.detectChanges();  // 변경감지 수행
    } catch(err) {
      log.isLoading = false 
    }
  }
}
